import type { MutationHookOptions } from '@apollo/client'
import {
  DeleteTrainingMembershipsDocument,
  DeleteTrainingMembershipsMutation,
  DeleteTrainingMembershipsMutationVariables,
  TrainingParticipantsDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  DeleteTrainingMembershipsMutation,
  DeleteTrainingMembershipsMutationVariables
>
export const useDeleteTrainingMemberships = (options?: Options) => {
  const [deleteTrainingMemberships, { loading }] = useMutation(DeleteTrainingMembershipsDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.bulkDestroyTrainingsTrainingMembership,
  })

  return {
    loading,
    deleteTrainingMemberships(variables: DeleteTrainingMembershipsMutationVariables) {
      return deleteTrainingMemberships({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [TrainingParticipantsDocument],
      })
    },
  }
}
